import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loading from "../Modals/Loading";
import expensesHeadService from "../Services/expensesHead";
import { LuEye } from "react-icons/lu";
import Head from "../Components/Head";

const ExpenseHead = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    expensesHeadService.fetchAllExpensesHead().then((res) => {
      setData(res.expenseHeads);
      setLoading(false);
    });
  }, []);

  return (
    <div className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg mb-20 bg-white">
      {loading ? (
        <Loading />
      ) : (
        <div>
          <Head
            heading={"Expense Head"}
            button_text={"Add Expense Head"}
            navigation={() => navigate("/expenses/head/add")}
          />

          <div className="table-div">
            <table>
              <thead>
                <tr className="border-y-2 text-left w-full text-black text-[10px]">
                  <th className="rounded-tl-xl pl-4 w-[1%] py-4">Sr No.</th>
                  <th className="rounded-tl-xl pl-4 w-[3%] py-4">
                    Expense Head
                  </th>
                  <th className="w-[2%] py-4">Type</th>
                  <th className="rounded-tr-xl text-center w-[2%] py-4">
                    View Head Expenses
                  </th>
                </tr>
              </thead>
              <tbody>
                {data?.map((expense, index) => (
                  <tr
                    key={index}
                    className="bg-accent border-b border-gray-100 text-left"
                  >
                    <td className="pl-4 py-4 w-[1%] font-bold text-blue-500">
                      {index + 1}.
                    </td>
                    <td className="pl-4 py-4 w-[2%]">{expense.head_title}</td>
                    <td className="py-4 w-[2%]">{expense?.type}</td>
                    <td
                      className="py-4 w-[2%] text-center text-sky-500 cursor-pointer"
                      onClick={() => {
                        navigate(`/expenses/expenseHead?id=${expense.id}`);
                      }}
                    >
                      <LuEye className="mx-auto" />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExpenseHead;
